import { useMemo } from "react";
import { bboxPolygon, bbox } from "@turf/turf";
import { MAX_ASSESSMENT_AREA_HA } from "react-migration/layouts/map/Multilayer/Bundle/Workbench/AssessmentTab/constants";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { areaHectares } from "react-migration/layouts/map/Multilayer/Bundle/Workbench/AssessmentTab/areaHectares";
import { Alert } from "react-migration/components/Alert";
import { SelectionGeometry } from "src/js/stores/map/store";

export function isSelectionTooLarge(geometry?: SelectionGeometry | null): boolean {
  if (!geometry) return false;
  return areaHectares(bboxPolygon(bbox(geometry)).geometry) > MAX_ASSESSMENT_AREA_HA;
}

export function useSelectionTooLargeToAssess(geometry?: SelectionGeometry | null) {
  return useMemo(() => isSelectionTooLarge(geometry), [geometry]);
}

export function ConsiderationsSelectionTooLargeWarning() {
  const { t } = useTranslation();

  return <Alert.Warning>{t("workbench.considerations.your_selection_is_too_large")}</Alert.Warning>;
}

type SiteTooLargeToAssessWarningProps = { geometry?: SelectionGeometry | null };

/**
 * This is mounted in the legacy Vue site card summary component.
 *
 * @deprecated
 */
export function LegacySiteCardSiteTooLargeToAssessWarning({ geometry }: SiteTooLargeToAssessWarningProps) {
  const { t } = useTranslation();
  const isTooLargeToAssess = useSelectionTooLargeToAssess(geometry);

  if (!isTooLargeToAssess) return null;

  return (
    <div className="p-3.5 pb-0">
      <Alert.Warning>{t("sites.card.considerations.your_site_is_too_large")}</Alert.Warning>
    </div>
  );
}

export function SiteReportSiteTooLargeToAssessWarning({ geometry }: SiteTooLargeToAssessWarningProps) {
  const { t } = useTranslation();
  const isTooLargeToAssess = useSelectionTooLargeToAssess(geometry);

  if (!isTooLargeToAssess) return null;

  return <Alert.Warning>{t(`sites.card.site_report.your_site_is_too_large`)}</Alert.Warning>;
}
